import styled from "styled-components";

export const GeneralContainer = styled.div`
  width: 100%;
  height: 100%;
  .header-label {
    font-size: 15px;
    font-weight: 700;
  }
`;
export const ContentTitle = styled.div`
  width: 100%;
  margin: 10px 0;
`;
export const ContentLocation = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 49% 49%;
  grid-column-gap: 2%;
`;
export const ContentUsers = styled.div`
  width: 100%;
  margin: 5px 0;
`;
export const SelectField = styled.div``;

export const ContentButtons = styled.div`
  display: flex;
  margin-top: 20px;
  width: 100%;
  height: 44px;
  justify-content: flex-end;
`;
export const ButtonSave = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  max-width: 129px;
  height: 43.21px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
`;

export const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: "#8F9BB3",
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgb(0 123 255 / 25%)",
    },
  }),
};
